import React, { useState } from 'react';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

function MentoringTabs() {
    const [key, setKey] = useState('');
  
    return (
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
      >
        <Tab eventKey="my-role" title="My Role">
        Web designer and developer
        </Tab>
        <Tab eventKey="impact" title="How Did I Have Impact?">
        <ul>
            <li>Collaborating with other developers using Git</li>
            <li>Re-designing the user interface</li>
            <li>Developing the front-end and integrating it with the back-end</li>
        </ul>
        </Tab>
        <Tab eventKey="appr" title="Appreciation">
        <span className="shout">Shout-out to: </span> 
        &nbsp;&nbsp;Former IT Force members &middot; Mahdia Aliyya &middot; Muhammad Ariq Basyar &middot;
        Althof Rafaella Ramdhan &middot; other IT Force members
        </Tab>
      </Tabs>
    );
}

function WebFukiTabs() {
    const [key, setKey] = useState('');
  
    return (
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
      >
        <Tab eventKey="my-role" title="My Role">
        Web designer and developer
        </Tab>
        <Tab eventKey="impact" title="How Did I Have Impact?">
        <ul>
            <li>Collaborating with other developers using Git</li>
            <li>Built new design system for the user interface</li>
            <li>Re-designing the user interface and user experience</li>
            <li>Developing the front-end and integrating it with the back-end</li>
        </ul>
        </Tab>
        <Tab eventKey="appr" title="Appreciation">
        <span className="shout">Shout-out to: </span> 
        &nbsp;&nbsp;Former IT Force members &middot; Mahdia Aliyya &middot; Faisal Hanif &middot;
        Muhammad Ichsanul Amal &middot; Althof Rafaella Ramdhan &middot; 
        Fahdii Ajmalal Fikrie &middot; other IT Force members
        </Tab>
      </Tabs>
    );
}

function SiputTabs() {
    const [key, setKey] = useState('');
  
    return (
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
      >
        <Tab eventKey="my-role" title="My Role">
        Web designer
        </Tab>
        <Tab eventKey="impact" title="How Did I Have Impact?">
        <ul>
            <li>Re-designing the user interface and user experience</li>
        </ul>
        </Tab>
        <Tab eventKey="appr" title="Appreciation">
        <span className="shout">Shout-out to: </span> 
        &nbsp;&nbsp;Former IT Force members &middot; Mahdia Aliyya &middot; Muhammad Oktoluqman Fakhrianto &middot;
        Fahdii Ajmalal Fikrie &middot; Sonia Rahmawati &middot; other IT Force members
        </Tab>
      </Tabs>
    );
}

export { MentoringTabs, WebFukiTabs, SiputTabs };